<script>
    import rpcjs from 'rpcjs';
    const {goto} = rpcjs.props;
    const Card = [
        {
            imgsrc: '/images/technologyPage/01.png',
        },
        {
            imgsrc: '/images/technologyPage/02.png',
        },
        {
            imgsrc: '/images/technologyPage/03.png',
        },
        {
            imgsrc: '/images/technologyPage/04.png',
        },
        {
            imgsrc: '/images/technologyPage/05.png',
        },
    ];
    const CardTitle = [
        {
            title: 'SEASONS',
            span: 'SUmmer - Winter - Spring - Fall',
            width: '20.073vw',
        },
        {
            title: 'SEASONAl ARTIFACTS',
            span: 'Trees - Water - FLora - LEAVES - GRASS',
            width: '38vw',
        },
        {
            title: 'Weather',
            span: 'Rain - Snow - Fog - ThUNDERSTORM',
            width: '22.052vw',
        },
        {title: 'HUMAN CHARACTERS', span: '', width: '36.208vw'},
        {title: 'ANIMALS', span: '120 Subspecies', width: '16.521vw'},
    ];
    let boxIndex = 0;
    /**
     * Adds two numbers together.
     */
    function next() {
        boxIndex++;
        if (boxIndex === 5) {
            goto('/roadmap');
        }
    }
    /**
     * Adds two numbers together.
     * @param {int} e The first number.
     */
    function keycheck(e) {
        e.preventDefault();
        if (e.key == 'ArrowRight') {
            next();
        }
    }
</script>

<svelte:window on:keyup={keycheck}/>

<section on:click={next} role="presentation" >
    <div class="cardWrraper">
        {#each Card as data, i}
            <div
                class="card card{i >= boxIndex ? i + boxIndex - boxIndex * 2 : 5 - boxIndex + i}"
            >
                <img
                    src={Card[i].imgsrc}
                    alt="card"
                    width="100%"
                    height="100%"
                />
            </div>
        {/each}
        {#if boxIndex < 5}
            <div class="textTitle" style="width:{CardTitle[boxIndex].width};">
                <h1>
                    {CardTitle[boxIndex].title}
                    <br />
                    <span>
                        {CardTitle[boxIndex].span}
                    </span>
                </h1>
            </div>
        {/if}
    </div>
</section>

<style>
    section {
        width: 100%;
        height: 100vh;
        overflow: hidden;
        font-style: normal;
        position: relative;
        font-family: "Montserrat";
        background-color: #01042200;
    }
    .card {
        width: 46.375vw;
        height: 24.688vw;
        overflow: hidden;
        position: absolute;
        border-radius: 1.704vw;
        transition-duration: 0.5s;
    }
    .card0 {
        bottom: 5vw;
        left: 25.313vw;
        z-index: 1;
    }
    .card1 {
        bottom: 5vw;
        left: 40.313vw;
        transform: scale(0.8);
    }
    .card2 {
        bottom: 5vw;
        left: 50.313vw;
        transform: scale(0.6);
        z-index: -1;
    }
    .card4 {
        bottom: 5vw;
        left: 11.313vw;
        transform: scale(0.8);
        z-index: 0;
    }
    .card3 {
        bottom: 5vw;
        left: 1.313vw;
        transform: scale(0.6);
        z-index: -1;
    }
    .textTitle {
        background-color: #ff007f;
        transition-duration: 0.4s;
        border-radius: 0vh 1.704vw;
        box-sizing: border-box;
        position: absolute;
        overflow: hidden;
        height: 9.63vh;
        padding: 0 2vh;
        bottom: 5vw;
        left: 25.3vw;
        z-index: 1;
    }
    .textTitle h1 {
        text-transform: uppercase;
        line-height: 9vh;
        font-size: min(3.125vw , 5.556vh);
        font-style: normal;
        font-weight: 900;
        color: #ffffff;
        margin: 0;
    }
    .textTitle h1 span {
        font-size:min(1.042vw , 1.852vh);
        position: relative;
        top: -7.2vh;
        left: 0vw;
    }
</style>
